import React from 'react'
import { Button, Flex, Icon, Radio, Text, useToast } from '@chakra-ui/react'
import { FaEye } from 'react-icons/fa'
import * as T from '../../../components/Table'
import { useProducao360 } from '../../../hooks/useProducao360'
import { user } from '../../../helpers/user'
import { HistoricoInicio } from './HistoricoInicio'
import { HistoricoTermino } from './HistoricoTermino'
import { HistoricoGeral } from './HistoricoGeral'
import { Link } from 'react-router-dom'

export const Producao360Item = ({ item }) => {
  const { mutation } = useProducao360()
  const { mutateAsync, isLoading } = mutation

  const toast = useToast({
    position: 'top',
    duration: 2000,
    isClosable: true,
  })

  const handleUpdate = async (coluna) => {
    const now = new Date()

    if (coluna === 'termino') {
      const lastHoraInicio = item.historico_inicio[item.historico_inicio.length - 1]?.data_inicio

      const dataInicio = new Date(lastHoraInicio)
      const diff = now - dataInicio

      if (diff < 60000) {
        toast({
          title: 'Erro',
          description: 'Não é possível finalizar a produção, pois a mesma foi iniciada a menos de 1 minuto',
          status: 'error',
        })

        return
      }
    }

    const params = {
      numero_nota: item.numeroNota,
      coluna,
      usuario: user.nome_usuario,
      codigo_produto: item.codigo_produto,
      id_solicitacao: item.id_solicitacao,
    }

    await mutateAsync(params)
  }

  function copyToClipboard(text) {
    navigator.clipboard.writeText(text)

    toast.closeAll()

    toast({
      title: 'Copiado',
      description: 'Texto copiado para a área de transferência',
      status: 'success',
    })
  }

  return (
    <T.Tr key={item.id}>
      <T.Td textAlign="start" px={3}>
        {item.nome}
      </T.Td>

      <T.Td>{item.pedido}</T.Td>
      <T.Td>
        <HistoricoGeral historicoGeral={item.historico_geral} itensPorLayout={item.itensPorLayout} />
      </T.Td>
      {/* <T.Td>{item.nomeIlustracao}</T.Td> */}
      <T.Td>
        <Text textDecoration="underline" cursor="pointer" onClick={() => copyToClipboard(item.nomeIlustracao)}>
          {item.nomeIlustracao}
        </Text>
      </T.Td>
      <T.Td>
        <Text textDecoration="underline" cursor="pointer" onClick={() => copyToClipboard(item.nome_arquivo)}>
          {item.nome_arquivo}
        </Text>
      </T.Td>
      <T.Td>
        <Flex alignItems={'center'} justifyContent="center">
          <Text as="a" href={item.link_ilustracao} target="_blank" rel="noreferrer">
            <Icon as={FaEye} color="#378BBF" fontSize={20} cursor="pointer" mx="auto" my="auto" />
          </Text>
        </Flex>
      </T.Td>
      <T.Td>
        <Flex flexDir="column" alignItems={'center'} gap={2} justifyContent="center" maxW="100px" overflow="hidden" mx="auto" textOverflow="ellipsis">
          <Button
            isLoading={isLoading}
            _focus={{ outline: 'none' }}
            size="xs"
            borderRadius={0}
            variant="outline"
            colorScheme="blue"
            onClick={() => handleUpdate('inicio')}
          >
            Atualizar {item.qtd_ilustracao + 1}/{item.total_produto}
          </Button>

          <HistoricoInicio historicoInicio={item.historico_inicio} />
        </Flex>
      </T.Td>
      <T.Td>
        <Flex flexDir="column" alignItems={'center'} gap={2} justifyContent="center" maxW="100px" overflow="hidden" mx="auto" textOverflow="ellipsis">
          <Button
            isLoading={isLoading}
            _focus={{ outline: 'none' }}
            size="xs"
            borderRadius={0}
            variant="outline"
            colorScheme="blue"
            onClick={() => handleUpdate('termino')}
          >
            Finalizar {item.qtd_ilustracao + 1}/{item.total_produto}
          </Button>
          <HistoricoTermino historicoTermino={item.historico_finalizacao} />
        </Flex>
      </T.Td>

      <T.Td>
        <Button as={'a'} target="_blank" variant="link" href={item.link_base}>
          Link base
        </Button>
      </T.Td>
    </T.Tr>
  )
}
